import React from 'react';
import PendingPage from '../../components/shared/Pending';
export default function AdminFinance() { return <PendingPage title="Finance & risk" description="Marketplace revenue, payouts, refunds and disputes." note="Finance endpoints are not yet available in the admin API." />; }
